"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSpinner = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var reactstrap_1 = require("reactstrap");
var classnames_1 = __importDefault(require("classnames"));
var icons_1 = require("../../../icons");
var NumberSpinner = function (_a) {
    var className = _a.className, _b = _a.editable, editable = _b === void 0 ? true : _b, disabled = _a.disabled, _c = _a.initialValue, initialValue = _c === void 0 ? 0 : _c, isDecimal = _a.isDecimal, _d = _a.max, max = _d === void 0 ? Number.MAX_SAFE_INTEGER : _d, _e = _a.min, min = _e === void 0 ? 0 : _e, onChange = _a.onChange, onDecrease = _a.onDecrease, onIncrease = _a.onIncrease, onMax = _a.onMax, onMin = _a.onMin, _f = _a.precision, precision = _f === void 0 ? 1 : _f, size = _a.size, _g = _a.step, step = _g === void 0 ? 1 : _g;
    var _h = (0, react_1.useState)(initialValue), inputValue = _h[0], setInputValue = _h[1];
    var _j = (0, react_1.useState)(), lastEmittedValue = _j[0], setLastEmittedValue = _j[1];
    var DecrementIcon = size === 'lg' ? icons_1.Delete32 : icons_1.Delete24;
    var IncrementIcon = size === 'lg' ? icons_1.Add32 : icons_1.Add24;
    var handleInputChange = function (num, event) {
        if (disabled)
            return;
        setInputValue(num);
        var currentValue = getValue(num);
        if (isDecimal) {
            if (realMatch("".concat(currentValue))) {
                if (min > 0 && Number(currentValue) === 0 && !event)
                    return;
                // Ex: min = 2 -> if was typed '2.' it will be  emitted '2' but the input keeps '2.' as value
                if (Number(currentValue) === min && !event) {
                    if (Number(currentValue) !== Number(lastEmittedValue) && onChange) {
                        emitChange(Number(currentValue));
                    }
                    return;
                }
                if (min > 9) {
                    if (Number(currentValue) < min && !event) {
                        return;
                    }
                }
                currentValue = Number(currentValue);
                if (!minReached(currentValue)) {
                    if (maxReached(currentValue)) {
                        currentValue = max;
                        if (onMax) {
                            onMax(max);
                        }
                        setInputValue(currentValue);
                    }
                }
                else {
                    if (onMin) {
                        onMin(min);
                    }
                    currentValue = min;
                    setInputValue(currentValue);
                }
                if (event === 'blur') {
                    setInputValue(currentValue);
                }
                if (currentValue !== Number(lastEmittedValue) && onChange) {
                    emitChange(currentValue);
                }
            }
        }
        else {
            if (intMatch("".concat(currentValue))) {
                currentValue = Number(currentValue);
                if (!minReached(currentValue)) {
                    if (maxReached(currentValue)) {
                        currentValue = max;
                        if (onMax) {
                            onMax(max);
                        }
                        setInputValue(currentValue);
                    }
                }
                else {
                    if (onMin) {
                        onMin(min);
                    }
                    currentValue = min;
                    setInputValue(currentValue);
                }
                if (event === 'blur') {
                    setInputValue(currentValue);
                }
                if (currentValue !== Number(lastEmittedValue) && onChange) {
                    emitChange(currentValue);
                }
            }
        }
    };
    var maxReached = function (num) {
        if (num === void 0) { num = null; }
        return num !== null ? num >= max : Number(inputValue) >= max;
    };
    var minReached = function (num) {
        if (num === void 0) { num = null; }
        return num !== null ? num <= min : Number(inputValue) <= min;
    };
    var countDecimals = function (value) {
        if (Math.floor(value) === value)
            return 0;
        return value.toString().split('.')[1].length || 0;
    };
    var countDecimalsFromString = function (value) {
        var numSplit = "".concat(value).split('.');
        return numSplit.length > 1 ? numSplit[1].length : 0;
    };
    var realMatch = function (value) { return /^-?\d+(?:\.\d+)?$|^-?\d+\.$/.test(value); };
    var intMatch = function (value) { return /^-?\d+$/.test(value); };
    var onBlur = function () {
        var currentValue = getValue(undefined);
        if (isDecimal) {
            if (realMatch("".concat(currentValue))) {
                handleInputChange(currentValue, 'blur');
            }
            else {
                handleInputChange(initialValue);
            }
        }
        else {
            if (intMatch("".concat(currentValue))) {
                handleInputChange(currentValue, 'blur');
            }
            else {
                handleInputChange(initialValue);
            }
        }
    };
    var parseNum = function (num) {
        if (isDecimal) {
            if (num === '.')
                return '0.';
            if (realMatch("".concat(num))) {
                var numSplit = "".concat(num).split('.');
                if ((numSplit.length > 1 && numSplit[1].length > 0 && numSplit[1].endsWith('0')) ||
                    (numSplit.length > 1 && numSplit[1].length === 0)) {
                    return num;
                }
                num = parseFloat(num);
            }
            else {
                num = parseFloat(num);
            }
        }
        else {
            num = parseInt(num);
        }
        if (isNaN(num)) {
            num = '';
        }
        return num;
    };
    var getValue = function (num) {
        var value = num !== null && num !== void 0 ? num : inputValue;
        if (isDecimal) {
            value = parseNum(value);
            if (typeof value == 'number') {
                if (countDecimals(value) > precision)
                    value = value.toFixed(precision);
            }
            else if (realMatch(value)) {
                if (countDecimalsFromString(value) > precision)
                    value = Number(value).toFixed(precision);
            }
        }
        if (typeof value == 'number') {
            return String(parseNum(value));
        }
        else {
            if (realMatch(value)) {
                if (countDecimalsFromString(value) === precision && value.endsWith('0')) {
                    value = Number(value);
                }
            }
            return String(value);
        }
    };
    var handleIncrease = function () {
        if (isDisabledButtonRight()) {
            return;
        }
        var num = parseNum(inputValue) + parseNum(step);
        if (onIncrease) {
            var increased_num = num;
            if (maxReached(num)) {
                increased_num = max;
            }
            onIncrease(increased_num);
        }
        handleInputChange(num, 'inc');
    };
    var handleDecrease = function () {
        if (isDisabledButtonLeft()) {
            return;
        }
        var num = parseNum(inputValue) - parseNum(step);
        if (onDecrease) {
            var decreased_num = num;
            if (minReached(num)) {
                decreased_num = min;
            }
            onDecrease(decreased_num);
        }
        handleInputChange(num, 'dec');
    };
    var emitChange = function (value) {
        onChange === null || onChange === void 0 ? void 0 : onChange(value);
        setLastEmittedValue(value);
    };
    var isDisabledButtonLeft = function () { return disabled || minReached(parseNum(inputValue)); };
    var isDisabledButtonRight = function () { return disabled || maxReached(parseNum(inputValue)); };
    return ((0, jsx_runtime_1.jsxs)(reactstrap_1.InputGroup, __assign({ className: (0, classnames_1.default)('input-group-spinner', className), size: size }, { children: [(0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ color: "darker-outline", className: "btn-square", onClick: handleDecrease, disabled: isDisabledButtonLeft(), title: "Subtract ".concat(step) }, { children: (0, jsx_runtime_1.jsx)(DecrementIcon, { className: "absolute-center" }) })), (0, jsx_runtime_1.jsx)(reactstrap_1.Input, { "data-testid": "number-spinner-input", className: "text-center", value: getValue(), readOnly: !(!disabled && editable), onChange: function (event) { return handleInputChange(event.target.value); }, onBlur: onBlur }), (0, jsx_runtime_1.jsx)(reactstrap_1.Button, __assign({ color: "darker-outline", className: "btn-square", onClick: handleIncrease, disabled: isDisabledButtonRight(), title: "Add ".concat(step) }, { children: (0, jsx_runtime_1.jsx)(IncrementIcon, { className: "absolute-center" }) }))] })));
};
exports.NumberSpinner = NumberSpinner;
